export default [
    {
        field: 'porc_afc_employer_undefined_contract',
        type: 'text',
        value: '',
        vuetifyProps: {
            label: 'C.I. Empleador',
            suffix: '%',
        },
        rules: [ 'required', 'isNotNegative' ],
    },
    {
        field: 'porc_afc_worker_undefined_contract',
        type: 'text',
        value: '',
        vuetifyProps: {
            label: 'C.I. Trabajador',
            suffix: '%',
        },
        rules: [ 'required', 'isNotNegative' ],
    },
    {
        field: 'porc_afc_employer_fixed_contract',
        type: 'text',
        value: '',
        vuetifyProps: {
            label: 'C.F. Empleador',
            suffix: '%',
        },
        rules: [ 'required', 'isNotNegative' ],
    },
    {
        field: 'porc_afc_worker_fixed_contract',
        type: 'text',
        value: '',
        vuetifyProps: {
            label: 'C.F. Trabajador',
            suffix: '%',
        },
        rules: [ 'required', 'isNotNegative' ],
    },
    {
        field: 'porc_afc_employer_undefined_contract_min_eleven_years',
        type: 'text',
        value: '',
        vuetifyProps: {
            label: 'C.I. Empleador Superior 11 Años',
            suffix: '%',
        },
        rules: [ 'required', 'isNotNegative' ],
    },
    {
        field: 'porc_afc_worker_undefined_contract_min_eleven_years',
        type: 'text',
        value: '',
        vuetifyProps: {
            label: 'C.I. Trabajador Superior 11 Años',
            suffix: '%',
        },
        rules: [ 'required', 'isNotNegative' ],
    },
]
